import React from 'react'

const MyClient = () => <div data-testid="my-client"></div>

export { MyClient }
